var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[(_vm.indexshow)?_c('index',{on:{"skipaction":_vm.skipaction}}):_vm._e(),(_vm.shareshow)?_c('share',{on:{"goindex":_vm.goindex}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }